module.exports = __webpack_public_path__ + "static/img/redEnvelopes.aee26581.png";